import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import getSubdomain from "../services/utils/utiltyFunctions";

interface AddSystemFormProps {
  handleSuccess: (system: any) => void;
  handleError: (error: any) => void;
}

const AddSystemForm: React.FC<AddSystemFormProps> = ({
  handleSuccess,
  handleError,
}) => {
  const subdomain = getSubdomain();
  const [systemName, setSystemName] = useState<string>("");
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [licenseKey, setLicenseKey] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await fetch("/api/v1/createSystem", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ systemName, subdomain }),
      });

      if (!response.ok) {
        throw new Error("Failed to create system.");
      }

      const data = await response.json();
      setLicenseKey(data.system.guid);
      handleSuccess(data.system);
    } catch (error) {
      handleError(error);
    } finally {
      setSubmitting(false);
    }
  };

  if (licenseKey) {
    return (
      <Alert variant="success">
        <Alert.Heading>System Created</Alert.Heading>
        <p>Your license key for <strong>{systemName}</strong>:</p>
        <code style={{ wordBreak: "break-all" }}>{licenseKey}</code>
      </Alert>
    );
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="formSystemName" className="mb-3">
        <Form.Label>System Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter system name"
          value={systemName}
          onChange={(e) => setSystemName(e.target.value)}
          required
        />
      </Form.Group>

      <Button variant="primary" type="submit" className="w-100" disabled={submitting}>
        {submitting ? (
          <>
            <Spinner animation="border" size="sm" /> Creating...
          </>
        ) : (
          "Add System"
        )}
      </Button>
    </Form>
  );
};

export default AddSystemForm;
